import React from 'react';
import { findError } from '@/utils/errors';
import FormObjectInput from './FormObjectInput';

const FormObjectInputs = ({
  category,
  code,
  component,
  errors,
  field,
  fields,
  onChange,
  section,
  text,
}) => (
  fields.map((item) => (
    <FormObjectInput
      category={category}
      code={code}
      component={component(item)}
      error={findError(errors, section, [field.name, item.name])}
      field={item}
      key={`form_object_${item.name}`}
      onChange={(value) => onChange(field, item, value)}
      parent={field}
      section={section}
      text={text(field, item)}
    />
  ))
);

export default FormObjectInputs;
